import { render } from "./DetalleLugar.vue?vue&type=template&id=c1ab5bc6&scoped=true"
import script from "./DetalleLugar.vue?vue&type=script&lang=js"
export * from "./DetalleLugar.vue?vue&type=script&lang=js"

import "./DetalleLugar.vue?vue&type=style&index=0&id=c1ab5bc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ab5bc6"]])

export default __exports__